import { SxProps } from "@mui/system"
export const rootText: SxProps = {
    color: 'common.white',
    textShadow: '0 0 10px black'
}